<template>
  <div>
    <!-- diagram -->
    <v-row v-for="(series, index) in chartsSeries" v-bind:key="series.id">
      <v-col>
        <apexchart type="line" height="350" :options="chartsOptions[index]" :series="series"></apexchart>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "ReanalysisChart",
  props: {
    model: Object,
    parameters: Array
  },
  data: function() {
    return {
      chartsOptions: [],
      chartsSeries: []
    };
  },
  methods: {
    getChartOptions() {
      return {
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "straight"
        },
        title: {
          text: "",
          align: "left"
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5
          }
        },
        xaxis: {
          type: "datetime",
          categories: [],
          title: {
            text: "срок"
          }
        },
        yaxis: {
          title: {
            text: ""
          }
        },
        tooltip: {
          x: {
            format: "dd/MM HH:mm"
          }
        }
      };
    }
  },
  watch: {
    model: {
      immediate: true,
      handler(val) {
        this.chartsOptions = [];
        this.chartsSeries = [];
        if (!val) return;

        for (const [index, parameter] of val.parameterGroups.entries()) {
          const chartOptions = this.getChartOptions();
          const parameterItem = this.parameters[index];
          chartOptions.yaxis.title.text = parameterItem.sname;
          chartOptions.title.text = `Тип уровня: ${parameterItem.level_type} Уровень ${parameterItem.level}`;
          chartOptions.xaxis.categories.push(
            ...parameter.values.map(x => x.code)
          );
          this.chartsOptions.push(chartOptions);

          this.chartsSeries.push([
            {
              id: parameter.code,
              name: parameter.code,
              data: parameter.values.map(x => x.value)
            }
          ]);
        }
      }
    }
  }
};
</script>